import React from 'react';
import { MerchantCard } from './MerchantCard';
import { PaginatorFooter } from '../../../components/PaginatorFooter';
import { useAuditorMerchantsData } from '../hooks/useAuditorMerchantsData';
import { Box, Center, Flex, Spinner, Text } from '@chakra-ui/react';

export const MerchantsTab = () => {
  const { data, error, loading, nextPage, prevPage } = useAuditorMerchantsData();

  return (
    <>
      {loading && <Center><Spinner /></Center>}
      {!!error && <Text color="red.500">Error cargando los datos.</Text>}

      {data && !data.total_elements && (
        <Text textAlign="center" width="full" color="neutral.600">
          No se encuentran sucursales asignadas a los criterios de búsqueda.
        </Text>
      )}

      {!error && data && !loading && (
        <Flex direction="column">
          <Box flexGrow={1} padding="xl" marginBottom="auto" overflowY="auto">
            {data.content.map((merch) => (
              <MerchantCard key={merch.id} merchant={merch} marginBottom="xl" />
            ))}
          </Box>

          <Box marginTop="auto" position="sticky" bottom="0">
            <PaginatorFooter
              pageable={data.pageable}
              total_elements={data.total_elements}
              onPreviousPage={prevPage}
              onNextPage={nextPage}
            />
          </Box>
        </Flex>
      )}
    </>
  );
};
